import { Events, animateScroll } from "react-scroll";

import { SELECTED_LEG_CARD_ID_KEY } from "@app/modules/results/helpers/views/constants";
import type { NavigationState } from "@app/modules/results/hooks/use-navigation";

import type { History } from "history";

import { OPEN_DRAWER_KEY, VIEW_KEY } from "./constants";
import { PAGES, DRAWERS } from "../../constants/pages";

export class TicketOptionsView {
  public static goTo(
    search_params: URLSearchParams,
    leg_card_id: string,
    history: History<NavigationState>,
    is_mobile: boolean
  ) {
    search_params.set(
      SELECTED_LEG_CARD_ID_KEY,
      encodeURIComponent(leg_card_id)
    );

    if (is_mobile) {
      search_params.set(VIEW_KEY, PAGES.RESULTS);
      search_params.set(OPEN_DRAWER_KEY, DRAWERS.TICKET_OPTIONS);

      history.push({
        search: search_params.toString()
      });
      return;
    } else {
      search_params.set(VIEW_KEY, PAGES.TICKET_OPTIONS);

      Events.scrollEvent.register("end", () => {
        Events.scrollEvent.remove("end");
        history.push({
          search: search_params.toString()
        });
      });

      animateScroll.scrollToTop({
        duration: 300
      });
    }
  }

  public static isCurrentlyViewed(
    searchParams: URLSearchParams,
    is_mobile: boolean
  ) {
    if (is_mobile) {
      return searchParams.get(OPEN_DRAWER_KEY) === DRAWERS.TICKET_OPTIONS;
    }

    return searchParams.get(VIEW_KEY) === PAGES.TICKET_OPTIONS;
  }
}
